import React from "react";

const ListOfLocks = React.createContext();

export default ListOfLocks;
